import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useReturnableItems } from "@babackapp/return-widget-components/hooks/use-returnable-items";
import { EnterIcon } from "@radix-ui/react-icons";
import { PlusIcon, ThumbsUpIcon } from "lucide-react";
import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { useWidgetParams } from "../../hooks/use-widget-params";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

export function LineItemConfirmation() {
  const { orderId, shopSlug } = useWidgetParams();
  const draft = useDraftReturn(orderId);
  const returnableItems = useReturnableItems(orderId, shopSlug);
  const t = useCustomText();
  const draftLineItemIds = new Set(draft?.lineItems.map((li) => li.lineItemId) ?? []);
  const hasMoreReturnableItems = returnableItems.some(
    (item) => !draftLineItemIds.has(item.line_item_id),
  );

  return (
    <WidgetPage variant="centered">
      <motion.span
        initial={{ opacity: 0, scale: 0.9, y: 5, rotate: 10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
        exit={{
          opacity: 0,
          y: 20,
          transition: { duration: 0.25, ease: "easeIn" },
        }}
        transition={{ delay: 0.2, type: "spring" }}
        style={{ transformOrigin: "top left" }}
      >
        <ThumbsUpIcon className="text-success-foreground size-10 mx-auto" />
      </motion.span>

      <Header>
        <HeaderTitle>{t("lineItemConfirmation.title")}</HeaderTitle>
        <HeaderDescription>
          {t("lineItemConfirmation.description")}
        </HeaderDescription>
      </Header>

      <AnimatedButtonRow variants={{}}>
        {hasMoreReturnableItems && (
          <AnimatedButtonContainer
            layoutId="line-item-back-button"
            disableVariants={{ enter: true, exit: true }}
            layout="position"
          >
            <Link to="../..">
              <Button variant="secondary">
                <PlusIcon />
                {t("common.addAnotherItem")}
              </Button>
            </Link>
          </AnimatedButtonContainer>
        )}
        <AnimatedButtonContainer
          layoutId="line-item-confirm-button"
          disableVariants={{ enter: true, exit: true }}
        >
          <Link to="../../../summary" relative="path">
            <Button>
              <EnterIcon />
              {t("common.summary")}
            </Button>
          </Link>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
